import {
	BAHAMAS_DESTINATION_CODE,
	CARIBBEAN_DESTINATION_CODE,
	FORT_LAUDERDALE_DESTINATION_CODE,
	MIAMI_DESTINATION_CODE,
} from 'components/FiltersModal/ActiveFilter/FilterOptions/constants';
import { SelectedOption } from 'components/FiltersProvider/types';
import { NumberOfGuestsSelection } from 'components/NumberOfGuests/types';
import { Dictionary } from 'contexts/appContext';
import { UpdateSelectionItem } from 'lib/mappers';
import { CUSTOM_FILTERS_KEY, ListFilterOption } from '../../../lib/apiClient';
import { NIGHTS_LABEL_APPENDER, NUMBER_OF_GUESTS_FILTER_KEY } from '../constants';
import { CustomFilterConfig, FilterDropdownConfig } from '../types';

export const getTotalSelectionForFilter = (
	historicalSelection: Array<SelectedOption>,
	filter: FilterDropdownConfig,
	filterKeyToCustomFilterConfig: Record<string, CustomFilterConfig>,
	enableUniqueFilters?: boolean,
) => {
	return historicalSelection.filter(
		(filterOption) =>
			filterOption.filterKey === filter.key ||
			filter.tabs?.some((tab) => tab.filterOwner === filterOption.filterKey) ||
			(enableUniqueFilters &&
				filterOption.filterKey === CUSTOM_FILTERS_KEY &&
				filterOption.containers?.includes(filterKeyToCustomFilterConfig[filter.key]?.container)),
	);
};

export const isUniqueFilter = (filter: Pick<SelectedOption | UpdateSelectionItem, 'containers'>) => {
	return Boolean(filter.containers);
};

export const isNumberOfGuestsFilter = (filter: Pick<FilterDropdownConfig, 'key'> | null) => {
	return filter?.key === NUMBER_OF_GUESTS_FILTER_KEY;
};

export const isPromoCustomFilter = (selectedValue: UpdateSelectionItem): boolean => {
	return Boolean(selectedValue.criteria?.promo);
};

export const getSelectionForNumberOfGuests = (selection: NumberOfGuestsSelection, dictionary: Dictionary): SelectedOption[] => {
	const { adults, children } = selection;
	const { labelAdult, labelAdults, labelChild, labelChildren } = dictionary;
	let stringSelection = `${adults} ${adults > 1 ? labelAdults : labelAdult}`;

	if (children > 0) {
		stringSelection += `, ${children} ${children > 1 ? labelChildren : labelChild}`;
	}

	return [
		{
			filterKey: NUMBER_OF_GUESTS_FILTER_KEY,
			option: {
				code: '',
				label: stringSelection,
			},
		},
	];
};

export const getValueForSelection = (option: Pick<ListFilterOption, 'code' | 'isSelected'>, selection: Array<SelectedOption>): Array<string> => {
	const value = [option.code];

	if (option.code === CARIBBEAN_DESTINATION_CODE && !option.isSelected) {
		const isBahamasSelected = Boolean(selection.find((item) => item.option.code === BAHAMAS_DESTINATION_CODE));

		if (!isBahamasSelected) {
			value.push(BAHAMAS_DESTINATION_CODE);
		}
	}

	// TODO: Implement LaunchDarkly feature flag for Miami and Fort Lauderdale
	if (option.code === MIAMI_DESTINATION_CODE && !option.isSelected) {
		const isFortLauderdaleSelected = Boolean(selection.find((item) => item.option.code === FORT_LAUDERDALE_DESTINATION_CODE));
		if (!isFortLauderdaleSelected) {
			value.push(FORT_LAUDERDALE_DESTINATION_CODE);
		}
	}

	if (option.code === FORT_LAUDERDALE_DESTINATION_CODE && !option.isSelected) {
		const isMiamiSelected = Boolean(selection.find((item) => item.option.code === MIAMI_DESTINATION_CODE));
		if (!isMiamiSelected) {
			value.push(MIAMI_DESTINATION_CODE);
		}
	}

	return value;
};

export const mapLabel = (label: string, filterKey: string | undefined, dictionary: Dictionary): string => {
	const { labelNightsAppender } = dictionary;

	if (filterKey === 'nights') {
		return label.replace(NIGHTS_LABEL_APPENDER, labelNightsAppender);
	}

	return label;
};
